module.exports = __webpack_public_path__ + "assets/img/recruit0.fa9096c2.png";